import { Add, Close, Remove } from "@mui/icons-material";
import { Button, Divider, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { CartItemType, CartItemTypeRes } from "../../../types/cartItemType";
import { useAppDispatch, useAppSelector } from "../../../State/Store";
import {
  deleteCartItemHandler,
  updateCartItemHandler,
} from "../../../State/customer/CartSlice";
import { fetchProductDetailById } from "../../../State/customer/ProductSlice";
import { useSelector } from "react-redux";

interface CartItemProps {
  cartItem: CartItemTypeRes;
  setMessage: React.Dispatch<React.SetStateAction<string | null>>;
}

export const CartItem: React.FC<CartItemProps> = ({ cartItem, setMessage }) => {

    
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  

  // inside your render (or just above it)
const qty = Number(cartItem?.quantity ?? 1);

const unitPrice = Number(
  cartItem?.productDetail?.sellingPrice  // prefer variant price
  ?? cartItem?.product?.sellingPrice     // fallback to product price
  ?? 0                                   // final fallback
);

const lineTotal = unitPrice * qty;

  const handleUpdateQuantity = async (
    cartItem: CartItemType,
    quantity: number,
    isMinus: boolean
  ) => {
    const newQuantity = isMinus ? quantity - 1 : quantity + 1;
    const updatedCartItem = { ...cartItem, quantity: newQuantity };

    setLoading(true); // Start loading state
    try {
      // Dispatch the updateCartItemHandler action

      await dispatch(updateCartItemHandler(updatedCartItem));

      // Optionally fetch the entire cart again for consistency
    } catch (error) {
      console.error("Failed to update quantity:", error);
    } finally {
      setLoading(false); // End loading state
    }
  };
  const handleDeleteCartItem = async (id: number, e: React.MouseEvent) => {
    e.preventDefault();

    await dispatch(deleteCartItemHandler(id));
  };





  return (
    <div className="border rounded-md relative">
      <div className="p-5 flex gap-3">
        <div>
          {cartItem?.product?.images && (
            <img
              className="w-[5vw] rounded-md"
              src={cartItem?.product?.images[0]}
              alt="not found"
            />
          )}
        </div>
        <div className="space-y-2">
          <h1 className="font-semibold text-lg">
            {cartItem?.product?.seller?.sellerName}
          </h1>
          <p className="text-gray-600 font-medium text-sm">
            {cartItem?.product?.title}
          </p>
          <p className="text-gray-600 text-xs">
            <strong>Description: </strong>
            {cartItem?.product?.description}{" "}
          </p>
          <p className="text-sm">7 days replacement available</p>

          <p className="text-sm text-gray-500">
            <strong>Color: </strong>
            {cartItem.productDetail.color}
          </p>
          <p className="text-sm text-gray-500">
            <strong>Size: </strong>
            {cartItem.productDetail.size}
          </p>
          <p className="text-sm text-gray-500">
            <strong>Quantity: </strong>
            {cartItem?.quantity}
          </p>
        </div>
      </div>
      {/* quantity */}
      <Divider />
      <div className="flex justify-between items-center">
        <div className="px-5 py-2 flex justify-between items-center">
          <div className="flex items-center gap-2 w-[140px] justify-between">
            <Button
              disabled={cartItem?.quantity === 1 || loading} // Disable during loading
              onClick={() =>
                handleUpdateQuantity(cartItem, cartItem?.quantity, true)
              }
            >
              <Remove />
            </Button>
            <span>{cartItem.quantity}</span>
            <Button
              disabled={loading} // Disable during loading
              onClick={() =>
                handleUpdateQuantity(cartItem, cartItem?.quantity, false)
              }
            >
              <Add />
            </Button>
          </div>
        </div>
        {/* total price */}
        <Divider />

        <div className="pr-5">
          <p className="text-gray-700 text-lg font-medium">
            {lineTotal.toLocaleString('en-US', { style: 'currency', currency: 'EUR' })}
          </p>
        </div>
        <div className="absolute top-1 right-1">
          <IconButton
            sx={{ cursor: "pointer" }}
            onClick={(e) => {
              handleDeleteCartItem(cartItem?.id, e);
            }}
            color="primary"
          >
            <Close />
          </IconButton>
        </div>
      </div>
    </div>
  );
};
